var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetOneProRfpShareDocumentMessageFile } from '@/actions/ProRfpShareDocumentActions';
import { ProfessionalRfpFileView } from '@/components/pages/rfp/professional/ProfessionalRfpFileView';
import Layout from '@/container/Layout';
import { notifyError } from '@/helpers/action';
import { isAdmin } from '@/helpers/auth';
import { useResourceUpload } from '@/hooks/file/useResource';
import { useResourceFromInput } from '@/hooks/file/useResourceView';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useRfpProfessionalFileMessageLog } from '@/pages/rfp/professional/RfpProfessionalFile/useRfpProfessionalFileMessageLog';
import { useRfpProfessionalFileSubmit } from '@/pages/rfp/professional/RfpProfessionalFile/useRfpProfessionalFileSubmit';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { openFileNewTab } from '@/utils/file/open';
/**
 * コンサルタント：ファイル共有ページを表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalFilePage = (props) => {
    const { changeFileShareData, fetchFileShare, fileShare, profile, rfp } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    /** ログインユーザーの情報 */
    const user = useMemo(() => ({
        clientId: '',
        firstName: profile.information.firstName,
        imageSrc: profile.information.file,
        isShowDetailPage: false,
        lastName: profile.information.lastName,
        professionalId: `${profile.id}`,
        professionalType: profile.information.type,
    }), [profile]);
    // メッセージ送信処理（下書き、公開、ファイルアップロード）
    const { onSubmit } = useRfpProfessionalFileSubmit({
        dispatch,
        fetchFileShare,
        id: rfp.id,
        unmountRef,
    });
    // メッセージに既読をつける処理
    const { displayLastMessage } = useRfpProfessionalFileMessageLog({
        changeFileShareData,
        dispatch,
        id: rfp.id,
    });
    const { inspectFileStatus, isUploading, uploadFileToStorage } = useResourceUpload({
        dispatch,
        unmountRef,
    });
    const { inputUploadFileEvent } = useResourceFromInput({
        fileType: 'object',
        uploadFileToStorage,
    });
    /**
     * ファイルダウンロードを実行
     */
    const onClickFileLink = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // IDに紐づく下書きデータのファイル情報を取得
            const { value } = event.currentTarget;
            const { payload } = yield wrapDispatch(dispatch, apiGetOneProRfpShareDocumentMessageFile({ path: { id: rfp.id, share_document_message_file_id: value } }, {}));
            if (!unmountRef.current) {
                openFileNewTab(payload.url);
            }
        }
        catch (error) {
            if (!unmountRef.current) {
                notifyError('ファイルの取得中にエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。');
            }
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }), [dispatch, unmountRef, rfp.id]);
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container' }, { children: _jsx(ProfessionalRfpFileView, { displayLastMessage: displayLastMessage, fileShare: fileShare, isAdminUser: isAdmin(profile), isUploading: isUploading, onClickDraft: onSubmit, onClickFileLink: onClickFileLink, onClickSubmit: onSubmit, onInspectFileStatus: inspectFileStatus, professionalId: profile.id, rfp: rfp, uploadFile: inputUploadFileEvent, user: user }) })));
};
